import React from 'react';
import ContentLoaderComp from 'react-content-loader';
import { I18nManager } from 'react-native';

const ContentLoader = props => {
  const rtl = I18nManager.getConstants().isRTL;
  return <ContentLoaderComp {...props} rtl={rtl} />;
};

export default ContentLoader;
